<template>
  <el-dialog
    :title="$t('ExcelConfig.Title')"
    :visible.sync="dialogVisible"
    width="600px"
    :before-close="hide"
    destroy-on-close
  >
    <p>{{ $t('ExcelConfig.Import') }}</p>
    <div class="text">
      1.{{ $t('ExcelConfig.AfterDownload') }}<br />
      2.{{ $t('ExcelConfig.ImportExcel') }}
      <el-button type="primary" @click="onDownload">{{ $t('ExcelConfig.Download') }}</el-button><br />
      3.{{ $t('ExcelConfig.MustHave') }}<br />
      4.{{ $t('ExcelConfig.Supports') }}<br />
    </div>
    <div>
      <BjImportFile
        ref="BjImportFile"
        accept=".xls,.xlsx"
        :limit-size="128 * 1024"
        auto-upload
        @importFile="importFile"
      >
        <template #top> </template>
        <template slot="default"> {{ $t('ExcelConfig.maximum') }} </template>
      </BjImportFile>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirm">{{ $t('ExcelConfig.Confirm') }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { importApi, commonApi, settingApi, baseDataApi } from '@/api';
import { downloadBlob, getEnvGlobalConfig } from '@/utils/index';
const DEFAULT_BUCKET_NAME = getEnvGlobalConfig('VUE_APP_UPLOAD_BUCKET_NAME');
export default {
  data() {
    return {
      dialogVisible: false,
      file: null,
      templateDownloadCode: null
    };
  },
  mounted() {
    this.getTenantTemplateCode();
  },
  methods: {
    // 根据租户获取下载模板code
    async getTenantTemplateCode() {
      const meaning = this.$store.getters.tenantNum;
      const res1 = await baseDataApi.getLovHeadersByLovCode({lovCode: 'SGOO.SKU_IMPORT'});
      const lovId = res1.lovId;
      const queryPrams = {
        lovCode: 'SGOO.SKU_IMPORT',
        lovId,
        meaning
      };
      const res2 = await baseDataApi.getLovValuesByLovId(queryPrams);
      if (!res2.content?.length) return;
      // 当前租户模板code
      this.templateDownloadCode = res2.content[0].value;
    },
    show() {
      this.file = null;
      this.dialogVisible = true;
    },
    hide() {
      this.dialogVisible = false;
    },
    onDownload() {
      importApi.getImportTemplateHeaders({
        templateCode: this.templateDownloadCode,
        size: 1,
        page: 0,
        total: 1,
        pageSize: 1,
        currentPage: 0
      }).then(res => {
        settingApi
          .downloadFileByUrl({
            bucketName: DEFAULT_BUCKET_NAME,
            url: res.content[0].templateUrl,
          })
          .then(resp => {
            downloadBlob(resp, 'SKU import template.xlsx');
          });
      });
    },
    importFile(file) {
      this.file = file;
    },
    confirm() {
      if (this.file) {
        commonApi
        .autoImport({
          prefix: 'sgoo',
          excel: this.file,
          templateCode: this.templateDownloadCode,
        })
        .then(res => {
          this.$message({
            message: this.$t('ExcelConfig.submitted'),
            type: 'success',
            duration: 5000,
          });
          this.hide();
          setTimeout(() => {
            this.$emit('submit');
          }, 1000);
        });
      } else {
        this.$message({
            message: this.$t('ExcelConfig.upload'),
            type: 'warning',
            duration: 5000,
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  font-size: 12px;
  line-height: 2;
}
</style>
